/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreProjectUserResponseDto } from '../models/core-project-user-response-dto';
import { projectUsersControllerCreate } from '../fn/project-users/project-users-controller-create';
import { ProjectUsersControllerCreate$Params } from '../fn/project-users/project-users-controller-create';
import { projectUsersControllerCreateBatch } from '../fn/project-users/project-users-controller-create-batch';
import { ProjectUsersControllerCreateBatch$Params } from '../fn/project-users/project-users-controller-create-batch';
import { projectUsersControllerDelete } from '../fn/project-users/project-users-controller-delete';
import { ProjectUsersControllerDelete$Params } from '../fn/project-users/project-users-controller-delete';
import { projectUsersControllerDeleteByProjectAndUser } from '../fn/project-users/project-users-controller-delete-by-project-and-user';
import { ProjectUsersControllerDeleteByProjectAndUser$Params } from '../fn/project-users/project-users-controller-delete-by-project-and-user';
import { projectUsersControllerFindAll } from '../fn/project-users/project-users-controller-find-all';
import { ProjectUsersControllerFindAll$Params } from '../fn/project-users/project-users-controller-find-all';
import { projectUsersControllerFindById } from '../fn/project-users/project-users-controller-find-by-id';
import { ProjectUsersControllerFindById$Params } from '../fn/project-users/project-users-controller-find-by-id';

@Injectable({ providedIn: 'root' })
export class CoreProjectUsersService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectUsersControllerFindAll()` */
  static readonly ProjectUsersControllerFindAllPath = '/o2-core/project-users/{tenant}';

  /**
   * Get project-user associations with optional filters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectUsersControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerFindAll$Response(params: ProjectUsersControllerFindAll$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>> {
    const obs = projectUsersControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get project-user associations with optional filters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectUsersControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerFindAll(params: ProjectUsersControllerFindAll$Params, context?: HttpContext): Observable<Array<CoreProjectUserResponseDto>> {
    const resp = this.projectUsersControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>): Array<CoreProjectUserResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectUsersControllerCreate()` */
  static readonly ProjectUsersControllerCreatePath = '/o2-core/project-users/{tenant}';

  /**
   * Add a user to a project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectUsersControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectUsersControllerCreate$Response(params: ProjectUsersControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectUserResponseDto>> {
    const obs = projectUsersControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a user to a project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectUsersControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectUsersControllerCreate(params: ProjectUsersControllerCreate$Params, context?: HttpContext): Observable<CoreProjectUserResponseDto> {
    const resp = this.projectUsersControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectUserResponseDto>): CoreProjectUserResponseDto => r.body)
    );
  }

  /** Path part for operation `projectUsersControllerCreateBatch()` */
  static readonly ProjectUsersControllerCreateBatchPath = '/o2-core/project-users/{tenant}/batch';

  /**
   * Add multiple users to a project (batch operation).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectUsersControllerCreateBatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectUsersControllerCreateBatch$Response(params: ProjectUsersControllerCreateBatch$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>> {
    const obs = projectUsersControllerCreateBatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add multiple users to a project (batch operation).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectUsersControllerCreateBatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectUsersControllerCreateBatch(params: ProjectUsersControllerCreateBatch$Params, context?: HttpContext): Observable<Array<CoreProjectUserResponseDto>> {
    const resp = this.projectUsersControllerCreateBatch$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>): Array<CoreProjectUserResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectUsersControllerFindById()` */
  static readonly ProjectUsersControllerFindByIdPath = '/o2-core/project-users/{tenant}/{id}';

  /**
   * Get a project-user association by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectUsersControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerFindById$Response(params: ProjectUsersControllerFindById$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectUserResponseDto>> {
    const obs = projectUsersControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a project-user association by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectUsersControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerFindById(params: ProjectUsersControllerFindById$Params, context?: HttpContext): Observable<CoreProjectUserResponseDto> {
    const resp = this.projectUsersControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectUserResponseDto>): CoreProjectUserResponseDto => r.body)
    );
  }

  /** Path part for operation `projectUsersControllerDelete()` */
  static readonly ProjectUsersControllerDeletePath = '/o2-core/project-users/{tenant}/{id}';

  /**
   * Remove a user from a project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectUsersControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerDelete$Response(params: ProjectUsersControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectUserResponseDto>> {
    const obs = projectUsersControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a user from a project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectUsersControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerDelete(params: ProjectUsersControllerDelete$Params, context?: HttpContext): Observable<CoreProjectUserResponseDto> {
    const resp = this.projectUsersControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectUserResponseDto>): CoreProjectUserResponseDto => r.body)
    );
  }

  /** Path part for operation `projectUsersControllerDeleteByProjectAndUser()` */
  static readonly ProjectUsersControllerDeleteByProjectAndUserPath = '/o2-core/project-users/{tenant}/by-ids/{projectId}/{userId}';

  /**
   * Remove a user from a project by IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectUsersControllerDeleteByProjectAndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerDeleteByProjectAndUser$Response(params: ProjectUsersControllerDeleteByProjectAndUser$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectUserResponseDto>> {
    const obs = projectUsersControllerDeleteByProjectAndUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a user from a project by IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectUsersControllerDeleteByProjectAndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectUsersControllerDeleteByProjectAndUser(params: ProjectUsersControllerDeleteByProjectAndUser$Params, context?: HttpContext): Observable<CoreProjectUserResponseDto> {
    const resp = this.projectUsersControllerDeleteByProjectAndUser$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectUserResponseDto>): CoreProjectUserResponseDto => r.body)
    );
  }

}
